import React from 'react';
import propTypes from 'prop-types';
import { AnimatedTextHeader } from '_ui-core-js/React/components/AnimatedTextHeader.jsx';
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { Button } from '_ui-core-js/React/components/Button.jsx';

export function Signpost(props) {

  const { 
    heading, 
    subheading, 
    primaryCta, 
    secondaryCta, 
    onClickCallbackPrimary,
    onClickCallbackSecondary,
    image 
  } = props;

  const block = 'c-signpost';

  return (
    <div
      className={`${block} utils__section-padding--uniform`}
      role='complementary'
    >
      <div className='container-xxxl'>
        <AnimatedTextHeader
        heading={heading}
        subheading={subheading}
        />
        <div className={`${block}__cta-container`}>
          {
            (primaryCta && primaryCta.label) &&
              <Button 
              label={primaryCta.label} 
              href={primaryCta.href}
              type='primary' 
              cssAnimation={true} 
              cssAnimationName='vertical-top-bottom-clip'
              cssAnimationDuration={0.5}
              cssAnimationDelay={0.5} 
              onClickCallback={onClickCallbackPrimary}
              />
          }
          { 
            (secondaryCta && secondaryCta.label) &&
              <Button 
              label={secondaryCta.label}
              href={secondaryCta.href}
              type='tertiary' 
              slim={true}
              cssAnimation={true} 
              cssAnimationDelay={1}
              onClickCallback={onClickCallbackSecondary}
              />
          }
        </div>
      </div>
      <CssAnimation
      enter={{ name: 'vertical-top-bottom-clip', duration: 1, delay: '1.25, hidden' }}
      triggerEnter='in-view-init'
      >
        <div className={`${block}__image-container`}>
          <img src={image} alt={image.alt || 'signpost image'}/>
        </div>
      </CssAnimation>
    </div>
  );
};

Signpost.propTypes = {
  heading: propTypes.string,
  subheading: propTypes.string, 
  primaryCta: propTypes.object, 
  secondaryCta: propTypes.object, 
  onClickCallbackPrimary: propTypes.func,
  onClickCallbackSecondary: propTypes.func,
  media: propTypes.object
};